// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import { useEffect } from "react";
import useTenantBranding from "../hooks/useTenantBranding";

/**
 * Sets the tenant's primary and secondary colors from the API as CSS variables
 * (--primary-color, --secondary-color) so you can use them app-wide via the
 * .primary-color / .secondary-color and .bg-primary-color / .bg-secondary-color classes.
 * Renders nothing.
 */
const TenantPrimaryColor = () => {
  const { primaryColor, secondaryColor } = useTenantBranding();

  useEffect(() => {
    const primary = primaryColor || "#3B82F6";
    const secondary = secondaryColor || "#1E40AF";
    document.documentElement.style.setProperty("--primary-color", primary);
    document.documentElement.style.setProperty("--secondary-color", secondary);
    return () => {
      document.documentElement.style.removeProperty("--primary-color");
      document.documentElement.style.removeProperty("--secondary-color");
    };
  }, [primaryColor, secondaryColor]);

  return null;
};

export default TenantPrimaryColor;
